import {
  CarouselEvents,
  CinemaEvents,
  SlidingCarousel,
} from "@otto-ec/global-pattern-sliding-carousel";

const elements = [
  { eventName: "cinema", className: "pl_cinema" },
  {
    eventName: "slidingcarousel",
    className: "pl_sliding-carousel",
  },
];

elements.forEach(({ eventName, className }) => {
  window.o_global.eventQBus.on(
    `assets.${eventName}.init`,
    (selector = `.js_${className}:not([data-${className.replace("_", "-")}-skip-init])`) => {
      const carousels = document.querySelectorAll<HTMLElement>(selector);
      Array.from(carousels).forEach((c) => {
        if (!SlidingCarousel.getInstance(c)) {
          new SlidingCarousel(window, c, className).init();
        }
      });
    },
  );

  window.o_global.eventQBus.on(
    `assets.${eventName}.move`,
    (data: { element: HTMLElement; index: number; scrolling: "smooth" | "snap" }) => {
      const cinema = SlidingCarousel.getInstance(data.element);
      cinema?.move({ index: data.index, noScrollSmoothing: data.scrolling === "snap" });
    },
  );
});

window.o_global.eventLoader.onReady(130, () => {
  elements.forEach(({ eventName }) => {
    window.o_global.eventQBus.emit(`assets.${eventName}.init`);
  });
});
